import React, { useEffect } from 'react';
import styled from 'styled-components';
import GetStarted from './GetStarted';
import RecentActivity from './RecentActivity';
import FavoritedReports from './FavoritedReports';
import Tiles from './Tiles';
import { useAnalytics } from '../../utils/analytics/useAnalytics';
import { pageViewed } from '../../utils/analytics/events/page/events';
import ScrollableWrapper from '../../components/ScrollableWrapper/ScrollableWrapper';

const Container = styled.main`
  flex: 1;
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  padding: 16px;
`;

const Home = () => {
  const { track } = useAnalytics();
  useEffect(() => {
    track(
      pageViewed({
        category: 'home',
        name: 'home',
        id: null,
      }),
    );
  }, [track]);

  return (
    <ScrollableWrapper>
      <Container>
        <GetStarted />
        <RecentActivity />
        <FavoritedReports />
        <Tiles />
      </Container>
    </ScrollableWrapper>
  );
};

export default Home;
